import { Component, OnDestroy, OnInit, inject } from "@angular/core";
import { FormGroup, AbstractControl } from "@angular/forms";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { LgdFormControlFactory, setEnabled } from "@tylertech/lgd-reactive-forms";

export interface PoApprovalDialogData
{
    readonly reqDate: Date;
}

@Component({
    selector: "po-approval-dialog-component",
    templateUrl: "./poApprovalDialog.tmpl.html",
    standalone: false
})
export class PoApprovalDialogComponent implements OnInit, OnDestroy
{
    private readonly dialogRef = inject<MatDialogRef<PoApprovalDialogComponent, Date | undefined>>(MatDialogRef);
    private readonly data = inject<PoApprovalDialogData>(MAT_DIALOG_DATA);

    private readonly destructor$ = new Subject<void>();
    readonly formGroup: FormGroup;

    private issueDate: Date;

    constructor()
    {
        this.formGroup = new FormGroup({
            issueDate: LgdFormControlFactory.date(undefined, false, {}),
            useIssueDate: LgdFormControlFactory.checkbox(),
        });
    }

    private get issueDateControl(): AbstractControl<Date> { return this.formGroup.get("issueDate"); }
    private get useIssueDateControl(): AbstractControl<boolean> { return this.formGroup.get("useIssueDate"); }

    private get reqDate(): Date { return this.data.reqDate; }

    ngOnDestroy(): void
    {
        this.destructor$.next();
        this.destructor$.complete();
    }

    ngOnInit(): void
    {
        const self = this;
        this.issueDate = new Date();

        subscribeToValueChanges(this.issueDateControl, (_newValue: Date) =>
        {
            this.issueDate = _newValue;
        });

        subscribeToValueChanges(this.useIssueDateControl, (_newValue: boolean) =>
        {
            this.issueDateControl.setValue(_newValue ? this.reqDate : new Date());
            setEnabled(this.issueDateControl, _newValue);

            this.issueDateControl.updateValueAndValidity();
        });

        function subscribeToValueChanges<T = unknown>(control: AbstractControl<T>, subscriptionFn: (newValue: T) => void): void
        {
            control.valueChanges.pipe(takeUntil(self.destructor$))
                .subscribe(x =>
                {
                    subscriptionFn(x);
                });
        }
    }

    close(): void
    {
        this.dialogRef.close();
    }

    create(): void
    {
        this.dialogRef.close(this.issueDate);
    }
}
